<template>
    <div class="products" data-aos="fade-right" :style="{
        position:top>height?'fixed':'absolute',
        top:top>height?'60px':'80px',
    }">
      <el-menu
          :defaultActive="defaultActive"
          class="el-menu-vertical-demo "
          @select="handleSelect"
      >
        <el-menu-item v-for="(item,index) in productsList" :index="item.src"
                      :disabled="item.disabled"
        >
          <span v-if="index!==0" v-html="item.title"></span>
          <div v-else style="cursor: pointer">
            <span v-html="item.title" class="redSelect"></span>
            <img :src="item.imgSrc" alt="" height="36px">
          </div>
        </el-menu-item>
      </el-menu>
    </div>
</template>

<script>
export default {
    data(){
      return {
        productsList:[
            {
              title:'EH-CLCMS<br>细胞全生命周期整体解决方案',
              imgSrc:require('@/assets/tyLogo.png'),
              src:'/products/cellNew',
              disabled:false
            },
            {
              title:'Ecell<br>细胞全生命周期信息管理系统',
              src:'/products/eCell',
              disabled:false
            },
            {
              title:'Cellcollect细胞采集系统',
              src:'/products/cellData',
              disabled:true
            },
            {
              title:'CellSelect细胞筛查系统',
              src:'/products/screen',
              disabled:true
            },
            {
              title:'CellCustomer储户CRM管理系统',
              src:'/products/stomer',
              disabled:true
            },
            {
              title:'CellMonitor<br>细胞资源运输监控管理平台',
              src:'/products/cellMonitor',
              disabled:true
            },
            {
              title:'CellData<br>细胞资源大数据管理平台',
              src:'/products/cellCloud',
              disabled:true
            },
            {
              title:'CellVision细胞资源库<br>数字孪生大屏可视化系统',
              src:'/products/cellVision',
              disabled:true
            },
            // {
            //   title:'AABB认证咨询培训服务',
            //   src:'/products/aabb',
            //   disabled:true
            // },
            // {
            //   title:'GMP标准认证培训服务',
            //   src:'/products/gmp',
            //   disabled:true
            // },
            {
              title:'设备/耗材选型咨询服务',
              src:'/products/cellEquipment',
              disabled:true
            },
            {
              title:'场地布局规划咨询',
              src:'/products/cellVenue',
              disabled:false
            },
            {
              title:'细胞资源库资料下载',
              src:'',
              disabled:true
            },
        ],
        defaultActive:'/products/eCell',
        top:0,
        height:window.innerHeight + 90,
      }
    },
    mounted() {
        // 监听滚动事件
        window.addEventListener('scroll', this.handleScroll, true)
        this.defaultActive = this.$route.path
    },
    methods:{
        handleScroll(){
          let top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset)
          this.top = top
        },
        handleSelect(src){
            this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
.products{
    position: absolute;
    left: 10px;
    top: -180px;
    z-index: 999999;
    visibility: visible!important;
    .el-menu-vertical-demo{
        background: none;
        border-right: none;
        .el-menu-item{
            width: 320px;
            height: 60px;
            box-sizing: border-box;
            padding: 0!important;
            line-height: 60px;
            font-size: 16px;
            margin-bottom: 2px;
            background: #ededed;
            letter-spacing: 3px;
            text-align: left;
            &>span{
                display: flex;
                align-items: center;
                padding: 0px 0 0px 20px;
            }
            &:hover{
                background: #006efd;
                color: #fff;
                span{
                    color: #fff;
                }
            }
        }
        .el-menu-item:nth-child(2),.el-menu-item:nth-child(6),.el-menu-item:nth-child(7),.el-menu-item:nth-child(8){
           span{
               line-height: 20px;
               padding: 10px 0 10px 20px;
            }
        }
        .el-menu-item:nth-child(1){
            cursor: auto;
            background: #ffe5e6;
            &:hover{
                span{
                    color: #333;
                }
            }
            div{
                display: flex;
                justify-content: space-between;
                align-items: center;
                line-height: 25px;
                height: 100%;
                padding: 0 20px;
                span{
                    display: flex;
                    align-items: center;
                    height: 100%;
                    font-size: 16px;
                    font-weight: bold;
                }
            }
        }
        .is-active{
            background: #ed1c25;
            border-left: 5px solid #a50006;
            span{
                color: #fff;
            }
        }
    }
}

</style>
